import { createSlice } from "@reduxjs/toolkit";
import { getTemplateThunk, createTemplateThunk, deleteTemplateThunk } from "./templatesThunk";

const initialState = {
    status: "idle",
    error: null,
    success: "",
    getTemplates: [],
    templateNameData: [],
    activeStep: 0,
    templateFlowPreview: [],
};

const templatesSlice = createSlice({
    name: "templates",
    initialState,
    reducers: {
        resetTemplateState: (state, action) => {
            state.status = "idle";
            state.error = null;
            state.success = "";
            state.activeStep = 0;
            state.templateNameData = [];
            state.templateFlowPreview = [];
        },
        setTemplateNameData: (state, action) => {
            state.templateNameData = action.payload;
        },
        setActiveNext: (state) => {
            state.activeStep += 1;
        },
        setActiveBack: (state) => {
            if (state.activeStep > 0) state.activeStep -= 1;
        },
        setTemplateFlow: (state, action) => {
            state.templateFlowPreview = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getTemplateThunk.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(getTemplateThunk.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.success = action.payload?.success ?? false;
                state.error = null;
                state.getTemplates = action.payload;
            })
            .addCase(getTemplateThunk.rejected, (state, action) => {
                state.status = "failed";
                state.error = null;
                state.error = action.payload || "Template are failed";
            })

            // Add the Branch
            .addCase(createTemplateThunk.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(createTemplateThunk.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.success = action.payload.success;
                state.error = null;
            })
            .addCase(createTemplateThunk.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload || "Template are failed";
                state.success = "";
            })

            // Delete Template
            .addCase(deleteTemplateThunk.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(deleteTemplateThunk.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.success = action.payload.success;
                state.error = null;
            })
            .addCase(deleteTemplateThunk.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload || "Template are failed";
                state.success = "";
            })
    },
});
export const { resetTemplateState, setTemplateNameData, setActiveNext, setActiveBack, setTemplateFlow } = templatesSlice.actions;
export default templatesSlice.reducer;